// Single source of truth for event logistics. Edit these as details are finalized.
export const EVENT = {
  dateLong: "Friday, September 25, 2026",
  dateStrip: "FRIDAY, SEPTEMBER 25, 2026",
  time: "7:00 – 9:00 PM",
  doors: "2-hour experience",
  durationLabel: "2-HOUR EXPERIENCE",
  city: "Metairie",
  venueName: "NOLA Pole & Aerials — Metairie Studio",
  venueAddress: "1017 Harimaw Ct E, Metairie, LA 70001",
  age: "21+",
  fromPrice: 35,
  includes:
    "Two hours of beginner-friendly movement, pose direction, music, two physical instant prints, and access to the full experience. No pole experience required.",
  policies: {
    refund:
      "All sales are final. Tickets are transferable — email us the new guest's name up to 48 hours before the event.",
    release:
      "By attending you consent to be photographed and filmed, and grant Fotos on the Geaux permission to use those images for promotion. You can ask not to be publicly featured at check-in.",
  },
  // Google Calendar template dates (local New Orleans time)
  calStart: "20260925T190000",
  calEnd: "20260925T210000",
};

export const FAQ = [
  ["What should I wear?", "Something you can move in and feel confident in — leggings or shorts and a fitted top work great. Bring grippy socks or go barefoot. Heels optional for photos. Skin contact helps on the pole, so avoid heavy lotion beforehand."],
  ["Do I need pole experience?", "None at all. This is beginner-friendly and guided the whole way — it's about movement, posing and confidence, not advanced pole fitness."],
  ["Are drinks provided or sold?", "Details are being finalized with the venue and will be shared with ticket holders before the event."],
  ["Is this 18+ or 21+?", "This is a 21+ experience. Please bring a valid government-issued ID for check-in."],
  ["Where is the event?", "Pole & Polaroids is at NOLA Pole & Aerials — Metairie Studio, 1017 Harimaw Ct E, Metairie, LA 70001."],
  ["Where should I park?", "The event is at NOLA Pole & Aerials — Metairie Studio. Any final arrival and parking notes will be shared with ticket holders before the event."],
  ["Can I attend without being photographed?", "Yes. Photography is the heart of the night, but you can opt out of being publicly featured at check-in and still enjoy the full experience."],
  ["When will digital photos arrive?", "If you add the Digital Foto Pack, selected edited images are delivered within about 5–7 days after the event."],
  ["Can tickets be transferred?", "Yes — tickets are transferable. Email us the new guest's name up to 48 hours before the event. All sales are final."],
  ["What happens if the event is canceled?", "If we cancel the event, you'll receive a full refund or the option to roll your ticket to the next POLE & POLAROIDS."],
  ["Is the venue accessible?", "We want everyone to enjoy the night. Reach out with any accessibility needs and we'll do our best to accommodate."],
  ["What's the physical activity level?", "Light to moderate and fully self-paced. You choose how much you move — the focus is confidence and great photos, not intensity."],
];
